import React, { RefObject } from 'react'
import PropTypes from 'prop-types'
import { StyleSheet, View, Text, Image, Dimensions, PixelRatio, Platform } from 'react-native'
import { ProductDisplayImage } from './product-display-image'
import { GearIcon } from './gear'

type ProductDisplayProps = {
  /** The defaultSKU to the product family. */
  defaultSKU: string,
  /** The partner specific SKU. */
  customSKU: string | null,
  /** The text color. */
  color: string | null,
  /** The view react ref to enable auto scroll. */
  viewRef?: RefObject<any> | null,
  /** On image layout function used to compute autoscroll coordinates. */
  onImageLayout: Function,
  partner: string,
}

export const ProductDisplay = (props: ProductDisplayProps) => {
  return (
    <View
      ref={props.viewRef as RefObject<View>}
      onLayout={e => {
        const windowHeight = Dimensions.get('window').height
        props.onImageLayout(e.nativeEvent.layout.y + windowHeight / 4 * 3)
      }}
      style={styles.container}
    >
      <Text style={styles.h1}>Scroll below to configure</Text>
      <ProductDisplayImage partner={props.partner} defaultSKU={props.defaultSKU} />
      <Text style={styles.h3}>{props.customSKU ?? props.defaultSKU}</Text>
      <Text style={styles.h2}>{props.color}</Text>
    </View>
  ) 
}

ProductDisplay.propTypes = {
  defaultSKU: PropTypes.string.isRequired,
  customSKU: PropTypes.string,
  color: PropTypes.string,
  viewRef: PropTypes.object,
  onImageLayout: PropTypes.func.isRequired,
}

ProductDisplay.defaultProps = {
  defaultSKU: 'VDHCH-RG-T0-A0-RC-8540',
  color: 'Black',
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  h1: {
    textAlign: 'center',
    fontSize: 30,
    color: 'gray',
  },
  h2: {
    textAlign: 'center',
    fontSize: 24,
    margin: 10,
  },
  h3: {
    marginTop: 20,
    marginBottom: 10,
    fontSize: 18,
  },
})
